module.exports = __webpack_public_path__ + "img/img_wugonggao.ff34d5c6.png";